module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAAEQAAAAB6PX+NAAAA/UlEQVQ4Ed2UsWoCURBF95HEXiFCahUCIhZBrLTQLmAlNn6Ago2FvV9i4xcEBDsXxU4LewsJpAhiI2wbZD1X3DbsSBpz4TDzhjfDzNthXRiGA8/zhuBDyzl3IlbDL4NVK4/kACJdinD4jAJG+/1ICwtowB62IDWhBE4Hgzbq8AmqkDIk3vNVRk1AHZ7/Yg5HoSmF3uEAr6zNkVgHvwdWzfWVK9esNDYHa8hDEaz6UYd9srTYM2hrsVWFeFLWqMB4/z9c1xsWGKQLPu/3oaGIPWAy8o36UvIOJP1lsiqAHStwg7ZaG3Uj6UcQ+RP8l2sME1tLdfMGI2jHTvvl4hme3uHKADRDggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/spread.png
// module id = bmgY
// module chunks = 6